import { createRouter, createWebHashHistory } from "vue-router";
import main from "../views/main.vue";
import { ElNotification } from "element-plus";

const routes = [
	{
		path: "/",
		name: "main",
		component: main,
		children: [
			{
				path: "/",
				name: "home",
				component: () => import("../views/home/home.vue"),
			},
			{
				path: "/project_my",
				name: "project_my",
				component: () => import("../views/rm/project_my.vue"),
			},
			{
				path: "/version_cur",
				name: "version_cur",
				component: () => import("../views/rm/version_cur.vue"),
			},
			{
				path: "/version_all",
				name: "version_all",
				component: () => import("../views/rm/version_all.vue"),
			},
			{
				path: "/rr_wait",
				name: "rr_wait",
				component: () => import("../views/rm/rr_wait.vue"),
			},
			{
				path: "/rr_reviewed",
				name: "rr_reviewed",
				component: () => import("../views/rm/rr_reviewed.vue"),
			},
			{
				path: "/rr_invalid",
				name: "rr_invalid",
				component: () => import("../views/rm/rr_invalid.vue"),
			},
			{
				path: "/ir_wait",
				name: "ir_wait",
				component: () => import("../views/rm/ir_wait.vue"),
			},
			{
				path: "/ir_suspend",
				name: "ir_suspend",
				component: () => import("../views/rm/ir_suspend.vue"),
			},
			{
				path: "/ir_reviewed",
				name: "ir_reviewed",
				component: () => import("../views/rm/ir_reviewed.vue"),
			},
			{
				path: "/ir_finish",
				name: "ir_finish",
				component: () => import("../views/rm/ir_finish.vue"),
			},
			{
				path: "/ir_invalid",
				name: "ir_invalid",
				component: () => import("../views/rm/ir_invalid.vue"),
			},
			{
				path: "/rm_unreview",
				name: "rm_unreview",
				component: () => import("../views/rm/rm_unreview.vue"),
			},
			{
				path: "/rm_notimes",
				name: "rm_notimes",
				component: () => import("../views/rm/rm_notimes.vue"),
			},
			{
				path: "/rm_reviewed",
				name: "rm_reviewed",
				component: () => import("../views/rm/rm_reviewed.vue"),
			},
			{
				path: "/rm_planed",
				name: "rm_planed",
				component: () => import("../views/rm/rm_planed.vue"),
			},
			{
				path: "/rm_release",
				name: "rm_release",
				component: () => import("../views/rm/rm_release.vue"),
			},
			{
				path: "/rm_dev",
				name: "rm_dev",
				component: () => import("../views/rm/rm_dev.vue"),
			},
			{
				path: "/rm_test",
				name: "rm_test",
				component: () => import("../views/rm/rm_test.vue"),
			},
			{
				path: "/rm_wait_product",
				name: "rm_wait_product",
				component: () => import("../views/rm/rm_wait_product.vue"),
			},
			{
				path: "/rm_wait_customer",
				name: "rm_wait_customer",
				component: () => import("../views/rm/rm_wait_customer.vue"),
			},
			{
				path: "/rm_finish",
				name: "rm_finish",
				component: () => import("../views/rm/rm_finish.vue"),
			},
			{
				path: "/rm_filelist",
				name: "rm_filelist",
				component: () => import("../views/rm/rm_filelist.vue"),
			},
			{
				path: "/review_apply",
				name: "review_apply",
				component: () => import("../views/rm/review_apply.vue"),
			},
			{
				path: "/review_review",
				name: "review_review",
				component: () => import("../views/rm/review_review.vue"),
			},
			{
				path: "/config_right",
				name: "config_right",
				component: () => import("../views/rm/config_right.vue"),
			},
			{
				path: "/config_flow",
				name: "config_flow",
				component: () => import("../views/rm/config_flow.vue"),
			},
			{
				path: "/kjrk",
				name: "kjrk",
				component: () => import("../views/pzx/kjrk.vue"),
			},
			{
				path: "/qxbmlb",
				name: "qxbmlb",
				component: () => import("../views/pzx/qxbmlb.vue"),
			},
			{
				path: "/qxyhlb",
				name: "qxyhlb",
				component: () => import("../views/pzx/qxyhlb.vue"),
			},
		],
	},
	{
		path: "/login",
		name: "login",
		component: () => import("../views/login/login.vue"),
	},
	{
		path: "/404",
		name: "404",
		component: () => import("@/views/noPage/404.vue"),
	},
	{
		path: "/linkLog",
		name: "linkLog",
		component: () => import("@/views/noPage/linkLog.vue"),
	},
	{
		path: "/:catchAll(.*)",
		redirect: "/404",
	},
];

const router = createRouter({
	history: createWebHashHistory(),
	routes,
});

const whiteList = ["login", "linkLog"];
router.beforeEach((to, from, next) => {
	if (localStorage.getItem("token")) {
		next();
	} else {
		if (whiteList.indexOf(to.name) !== -1) {
			next();
		} else {
			ElNotification({
				title: "系统提示",
				message: "未登录，请登录",
				type: "error",
				duration: 3000,
			});
			next({ path: "/login" });
		}
	}
});
export default router;
